// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0c0de44","239":"6c003832","453":"c9fcdfc5","455":"93c6d92c"}[chunkId] + ".chunk.js";
};